import { Component, Input } from '@angular/core';
import { KeyValue } from '@angular/common';
import {
  CalculatedGrouping,
  LocalStorageService,
  ProjectManagerService,
} from '@ops/shared-types';
import { openClose } from '../../animations/open-close.animation';
import { rotate } from '../../animations/rotate.animation';
import { Miscellanious } from '@ops/global-config';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-expense-accordion',
  templateUrl: './expense-accordion.component.html',
  styleUrls: ['./expense-accordion.component.scss'],
  animations: [openClose, rotate],
})
export class ExpenseAccordionComponent {
  @Input() data: CalculatedGrouping;
  isOpen = false;

  readonly costTitles = {};

  originalOrder = (
    a: KeyValue<number, string>,
    b: KeyValue<number, string>
  ): number => {
    return 0;
  };
  toggle() {
    this.isOpen = !this.isOpen;
  }

  getPaidAmount(item: any) {
    return item.paidAmount;
  }

  getExpectedAmount(item: any) {
    return item.expectedAmount;
  }

  getCostName(item: any) {
    return item.costName;
  }

  companyCurrencyCode?: string;
  projectCurrency?: string;
  constructor(
    private projectService: ProjectManagerService,
    private localStorageService: LocalStorageService,
    private translate: TranslateService
  ) {
    this.projectCurrency =
      this.projectService.getCurrentProject()?.projectCurrency ?? '';

    this.costTitles = {
      expenseTypeCosts: this.translate.instant(
        'projectEstimate.payments.expenses.costsPerExpenseType'
      ),
      paymentMethodCosts: this.translate.instant(
        'projectEstimate.payments.expenses.costsPerPaymentMethod'
      ),
      departmentCosts: this.translate.instant(
        'projectEstimate.payments.expenses.costsPerDepartment'
      ),
    };

    this.companyCurrencyCode =
      this.localStorageService.getCurrentCompany()?.baseCurrencyCode;
  }

  get companyBaseCurrency() {
    return Miscellanious.currencySymbolFromCode(
      'en-US',
      this.companyCurrencyCode
    );
  }

  get projectBaseCurrency() {
    return Miscellanious.currencySymbolFromCode('en-US', this.projectCurrency);
  }
}
